import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7470c99c&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/mobile/personal-detail/_personal-detail.scss?vue&type=style&index=0&id=7470c99c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7470c99c",
  null
  
)

export default component.exports